import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { persistStore } from "redux-persist";
import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { HelmetProvider } from "react-helmet-async";
import HistoryRouter from "./stores/services/historyRouter";
import configureStore from "./stores";
import AuthProvider from "./contexts/AuthContext";
import "@mantine/dropzone/styles.css";
import "@mantine/dates/styles.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const { store } = configureStore();
let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MantineProvider>
          <Router>
            <HistoryRouter />
            <AuthProvider>
              <App />
            </AuthProvider>
          </Router>
        </MantineProvider>
      </PersistGate>
    </Provider>
  </HelmetProvider>
  // </React.StrictMode>
);

reportWebVitals();
